export const URL_COMPRESS = "?x-oss-process=image/resize,p_12"
